import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type IMessageScrollerLoaderProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useMessageScrollerRootContext,
    useMessageScrollerSelector,
    useMessageScrollerContext
} from "../../context";
import Loading from "../../../loading";
import Text from "../../../text";

const MessageScrollerLoader: FC<IMessageScrollerLoaderProps> = ({
    customTheme
}) => {
    const context = useMessageScrollerContext();

    const rootContext = useMessageScrollerRootContext();

    const currentTheme = customTheme ?? rootContext?.customTheme;

    const {
        controlHeights,
        shapeConfigs,
        iconSizes,
        spaces
    } = NCoreUIKitTheme.useContext(currentTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(rootContext?.customLocalize);

    const isLoadingOlder = useMessageScrollerSelector(context, (snapshot) => snapshot.isLoadingOlder, false);

    const {
        container: containerDynamicStyle
    } = useStyles({
        controlHeights,
        shapeConfigs,
        spaces
    });

    if(!isLoadingOlder) {
        return null;
    }

    return <View
        style={[
            stylesheet.container,
            containerDynamicStyle
        ]}
        role="status"
    >
        <Loading
            customTheme={currentTheme}
            size={iconSizes.small}
            aria-hidden={true}
        />
        <Text
            customTheme={currentTheme}
            variant="bodyMediumSize"
            color="mid"
        >
            {localize("loading-older-messages")}
        </Text>
    </View>;
};
export default MessageScrollerLoader;
